import React from "react";
import moment from "moment";
import AddExerciseModal from "./add-exercise";
import { RillContext } from "../../rill/RillReact/share/base";

class CalendarAddExerciseModal extends React.Component {
  render() {
    const {
      query,
      activeUserToRequest: {
        exerciseLibrary: { assistant },
      },
    } = this.context.locals;
    let date = moment.utc(query.day);

    return (
      <AddExerciseModal
        {...this.props}
        date={date}
        reqSource="calendar"
        lengthAssistantLibrary={assistant.length}
        secondaryAdded={query.secondaryAdded}
      />
    );
  }
}

CalendarAddExerciseModal.contextType = RillContext;

export default CalendarAddExerciseModal;
